<script setup lang="ts">
interface Props {
  params: {
    count: number;
    current: number;
    perPage: number;
    max?: number;
  };
}

defineProps<Props>();

import type { Attr } from "~/types";

import { alphabetToCity } from "@/utils/sekou/area";

const s = useSekouQuery();
const attrs = inject<Attr[]>("attrs", []);

const attrNames = computed(() => {
  return s.value.attr_num.map((attr_num) => {
    const attr = attrs.find((o: any) => o.attr_num == attr_num);
    return attr?.cate_name || "";
  });
});
</script>

<template>
  <div class="flex justify-between y-2">
    <div class="whitespace-nowrap overflow-hidden">
      <p class="text-sm overflow-hidden text-ellipsis h-6">
        <span v-if="s.attr_num?.length">分類：{{ attrNames.join(" ") }}</span>
        <span v-else-if="s.kw?.length">キーワード：{{ s.kw.join(" ") }}</span>
        <span v-else-if="s.pref || s.city"
          >エリア：{{ s.pref }}{{ alphabetToCity(s.city) }}</span
        >
        <span v-else-if="s.item.item_cd"
          >商品名：{{ s.item.item_name + s.item.src_name }}</span
        >
        <span v-else>すべて</span>
      </p>
      <p class="text-sm">
        <span class="text-2xl bold">{{ params.count }}</span>
        件
      </p>
    </div>
    <PaginationCompact class="" :params="params" />
  </div>
</template>
